import type { ISelectOption } from '@cian/ui-kit';

export const DEFAULT_POLYGONS: ISelectOption[] = [
  { value: 'altai', label: 'Алтайский край' },
  { value: 'volgograd', label: 'Волгоградская область' },
];
